<!--suppress JSUnusedGlobalSymbols -->
<app-blade #blade [subTitle]="subTitle" [title]="article?.title || 'Help'" [wide]="true">
  <div *ngIf="!article" class="loading">
    <app-busy-indicator class="dots"></app-busy-indicator>
  </div>
  <article *ngIf="article" [innerHTML]="article.body"></article>
</app-blade>
